module.exports = __webpack_public_path__ + "img/proceso_a.9ccd427d.png";